import React, { useRef, useState } from 'react';
import { edgeToEdgeImageSizes, isOnServer, toKebabCase, useCoversViewport } from '../utils';

import FeaturesParallax from '../components/Workspace/FeaturesParallax';
import FloatingQuoteButton from '../components/Device/FloatingQuoteButton';
import GetInTouch from '../components/Workspace/GetInTouch';
import HeroB from '../components/Workspace/HeroB';
import PageHeading from '../components/Workspace/PageHeading';
import RoomDownloads from '../components/Workspace/RoomDownloads';
import RoomExperience from '../components/Workspace/RoomExperience';
import ScrollProgress from '../components/ScrollProgress';
import WorkspaceProducts from '../components/Workspace/WorkspaceProducts';
import styles from './workspaceb.module.scss';

const sections = [
  {
    title: 'The Room',
    index: 0,
  },
  {
    title: 'Ways to collaborate',
    index: 1,
  },
  {
    title: 'Products',
    index: 2,
  },
  {
    title: 'Room Experiences',
    index: 3,
  },
  {
    title: 'Downloads',
    index: 4,
  },
  {
    title: 'Get Quote',
    index: 5,
  },
];

export default function WorkspaceB({ data: { workspace, description } }) {
  const defaultImage = edgeToEdgeImageSizes(workspace.hotspotHero?.image);
  const [bundle] = useState(workspace.bundles[0]);
  let coverRef = useRef(null);
  let isCovering = useCoversViewport(coverRef);
  let pathname = isOnServer ? '' : window.location.pathname;
  let [heroImage] = workspace.images;

  return (
    <>
      <div ref={coverRef}>
        <PageHeading heading={workspace.heading} description={description.description} image={defaultImage} />
        <div id={toKebabCase(sections[0].title)} />
        <HeroB
          heroImage={heroImage}
          hotspotHero={workspace.hotspotHero}
          infocardAlternatePos={workspace.infoboxAltPosition}
        />
        <div id={toKebabCase(sections[1].title)} />
        <FeaturesParallax features={workspace.features} heading={workspace.featuresHeading} />
      </div>
      <div id={toKebabCase(sections[2].title)} />
      <WorkspaceProducts bundles={workspace.bundles} />

      <div id={toKebabCase(sections[3].title)} />
      <RoomExperience roomExperience={workspace.roomExperience} />

      <div id={toKebabCase(sections[4].title)} />
      {Boolean(workspace.features) && <RoomDownloads assets={workspace.features} />}

      <div id={toKebabCase(sections[5].title)} />
      <GetInTouch />

      <ScrollProgress
        sections={sections}
        selectHandler={event => {
          window.location.hash = '#' + toKebabCase(sections[event.index].title);
        }}
      />
      <FloatingQuoteButton
        product={isCovering ? bundle : null}
        heading={'Buy this room'}
        tracking={{
          category: 'Workspace',
          action: `Floating 'Buy this room' button clicked`,
          label: pathname,
        }}
        className={styles.floatingQuoteButton}
      />
    </>
  );
}
